<header class="profile-header">
  <div class="profile-header__inner">
    <!-- Avatar -->
    <div class="profile-header__avatar-wrap">
      @if (avatarUrl(); as url) {
        <img [src]="url" [alt]="fullName()" class="profile-header__avatar" (error)="onAvatarError()" />
      } @else {
        <img
          [src]="mascotAvatar"
          [alt]="fullName()"
          class="profile-header__avatar profile-header__avatar--mascot"
        />
      }
    </div>

    <!-- Info -->
    <div class="profile-header__info">
      <h1 class="profile-header__name">{{ fullName() }}</h1>
      <span class="profile-header__email">{{ user().email }}</span>

      @if (clientSince(); as since) {
        <span class="profile-header__since">{{ since }}</span>
      }

      @if (showUnverified()) {
        <div class="profile-header__verify">
          <p class="profile-header__unverified">{{ copy.UNVERIFIED_EMAIL }}</p>
          <!-- Botón compartido con ajustes (W3): la misma espera de 60 s y el 429 (B43). -->
          <app-mail-cooldown-button
            channel="resend"
            [label]="settingsCopy.RESEND_BUTTON"
            [waitLabel]="settingsCopy.RESEND_WAIT"
            (send)="resend()"
          />
          <p class="profile-header__notice" role="status">
            @if (resendNotice(); as notice) {
              <span [class.profile-header__notice--error]="notice.tone === 'error'">{{ notice.text }}</span>
            }
          </p>
        </div>
      }
    </div>
  </div>
</header>
